export type OrganizationTab = {
  key: string;
  labelKey: string;
  getHref: (orgId: string) => string;
};

export const organizationTabList: OrganizationTab[] = [
  {
    key: 'overview',
    labelKey: 'organization:detail.tabs.overview',
    getHref: (orgId: string) => `/admin/back-office/organizations/${orgId}`,
  },
  {
    key: 'managers',
    labelKey: 'organization:detail.tabs.managers',
    getHref: (orgId: string) =>
      `/admin/back-office/organizations/${orgId}/managers`,
  },
  {
    key: 'parks',
    labelKey: 'organization:detail.tabs.parks',
    getHref: (orgId: string) =>
      `/admin/back-office/organizations/${orgId}/parks`,
  },
  {
    key: 'supervisors',
    labelKey: 'organization:detail.tabs.supervisors',
    getHref: (orgId: string) =>
      `/admin/back-office/organizations/${orgId}/supervisors`,
  },
  {
    key: 'technicians',
    labelKey: 'organization:detail.tabs.technicians',
    getHref: (orgId: string) =>
      `/admin/back-office/organizations/${orgId}/technicians`,
  },
  {
    key: 'tags',
    labelKey: 'organization:detail.tabs.tags',
    getHref: (orgId: string) =>
      `/admin/back-office/organizations/${orgId}/tags`,
  },
];
